import { render } from "./FavoriteIcon3.vue?vue&type=template&id=2c658898&scoped=true"
import script from "./FavoriteIcon3.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon3.vue?vue&type=script&lang=js"

import "./FavoriteIcon3.vue?vue&type=style&index=0&id=2c658898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c658898"]])

export default __exports__